module.exports = __webpack_public_path__ + "static/img/bigquery_logo.82f57155.png";